export default {
    Title: 'Tham số báo cáo',
    ViewReport: 'Xem báo cáo',
    FromDate: 'Từ ngày',
    ToDate: 'Đến ngày',
    All: 'Tất cả',
    Option: 'Tùy chọn',
    TemplateReport: 'Mẫu báo cáo',
    ChoosePeriod: 'Chọn kỳ báo cáo',
    SelectAll: '<<Tất cả>>',
    Stock: 'Kho',
    Account: 'Tài khoản',
    InventoryCategory: 'Loại vật tư/ CCDC'
};
